import JSEncrypt from "jsencrypt";

let encryptor = null;
let publicKey = null;
let privateKey = null;

/*
 * RSA生成公私鑰
 */
function generateRSAKey() {
  encryptor = new JSEncrypt({ default_key_size: 2048 });
  const keyPair = encryptor.getKey();
  publicKey = keyPair.getPublicKey();
  privateKey = keyPair.getPrivateKey();
}

/*
 * 取得RSA公鑰
 */
export function getRSAPublicKey() {
  if (!publicKey) {
    generateRSAKey();
  }
  return publicKey;
}

/*
 * RSA加密：資料
 */
export function rsaEncrypt(value) {
  if (!publicKey) {
    generateRSAKey();
  }
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(value);
}

/*
 * RSA解密：資料
 */
export function rsaDecrypt(value) {
  if (!privateKey) {
    generateRSAKey();
  }
  encryptor.setPrivateKey(privateKey);
  return encryptor.decrypt(value);
}
